import { CmsContactUsPage } from '../../models/contact-us/cms-contact-us-page.type';

export const mockCmsContactUsPage: CmsContactUsPage = {};
